




import Vue from 'vue';
import ImportantInformationDetail from '@/components/important-information/important-information-detail.component.vue';

export default Vue.extend({
  components: {
    'important-information-detail': ImportantInformationDetail,
  },
});
